import fetch from 'node-fetch';

type NotificationResponse = { hasNotification: boolean };

export const getNotificationLite = async (
  notificationLiteUrl: string
): Promise<NotificationResponse> => {
  try {
    const authToken =
      typeof window !== 'undefined'
        ? await window.auth0?.getTokenIfAuthenticated()
        : undefined;

    if (!authToken) {
      return { hasNotification: false };
    }

    const res = await fetch(notificationLiteUrl, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    const response = (await res.json()) as NotificationResponse;

    return response;
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    console.error(`Notification Lite Fetch failed: ${message}`);
    return { hasNotification: false };
  }
};
